//
// Body of the release-notes popover: a dated block per release, each with an
// optional note and its one-line feature summaries.
//
const featureLineHtml = (feature, translate) => {
  const { key, icon } = (typeof feature === 'string') ? { key: feature } : feature;
  const picto = (icon) ? `<span class="px-tutorial-release-picto" style="--px-picto: url('${icon}')"></span>` : '';
  return `<li>${picto}${translate(key, 'releaseNotes')}</li>`;
};

const releaseNotesHtml = (releases, translate, lang) => `
  <p>${translate('whatsNewIntro', 'tutorial')}</p>
  ${releases.map((release) => `
    <div class="px-tutorial-release">
      <div class="px-tutorial-release-date">
        ${`- ${new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric' })
          .format(new Date(release.date))} -`}
      </div>
      ${release.noteKey
        ? `<p class="px-tutorial-release-note">${translate(release.noteKey, 'releaseNotes')}</p>`
        : ''}
      <ul>
        ${release.featureKeys.map((feature) => featureLineHtml(feature, translate)).join('')}
      </ul>
    </div>
  `).join('')}
  <p>${translate('whatsNewOutro', 'tutorial')}</p>
`;

export default releaseNotesHtml;
